import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

// export const getAdditionalInformationDetailYuno = (payment) => [
//   {
//     label: 'Es contracargo',
//     value: payment?.is_chargeback ? 'Sí' : 'No',
//   },
//   {
//     label: 'Es fraude',
//     value: payment?.is_fraud ? 'Sí' : 'No',
//   },
// ];

export const getIdentifiersYuno = (payment) => [
  {
    label: 'ID Solicitud de pago',
    key: 'payment_request_id',
    value: payment?.provider_transaction_id,
  },
  {
    label: 'ID de la operación',
    value: payment?.yuno_payment_id || 'No disponible',
  },
  {
    label: 'ID Cliente',
    value: payment?.customer_id,
  },
  {
    label: 'ID Pago',
    value: payment?.payment_id,
  },
];

export const getYunoTransactions = (orderDetails) => [
  {
    label: 'Fecha de transacción',
    value: convertToMexicoTime(orderDetails?.payment_created),
  },
  {
    label: 'Fecha de creación',
    value: convertToMexicoTime(orderDetails?.payment_created),
  },
  {
    label: 'Monto',
    value: <CurrencyFormatter amount={orderDetails?.amount} />,
  },
  {
    label: 'Tarjeta enmascarada',
    value: orderDetails?.masked_card,
  },
  {
    label: 'Estatus de pago',
    value: orderDetails?.status,
  },
  {
    label: 'Cuotas',
    value:
      orderDetails?.installments === 1 ? 'Contado' : `${orderDetails?.installments || '0'} meses`,
  },
  {
    label: 'Método de pago',
    value: orderDetails?.method_type || 'No disponible',
  },
  {
    label: 'Comprobante de pago',
    value: orderDetails?.receipt_url ? 'Sí' : 'No',
  },
  {
    label: 'Código de autorización',
    value: orderDetails?.authorization_code || 'No disponible',
  },
];
